export const getLocalFromInterPhone = (interPhoneNumber: string) => {
  if (interPhoneNumber.length > 0 && interPhoneNumber.slice(0, 2) === '66') {
    return interPhoneNumber.replace('66', '0')
  }
  return interPhoneNumber
}

export const getSeparatedPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) {
    return 'N/A'
  }
  if (phoneNumber.length === 9 && phoneNumber.slice(0, 2) === '02') {
    return phoneNumber.slice(0,2) + '-' + phoneNumber.slice(2,5) + '-' + phoneNumber.slice(5, phoneNumber.length)
  } else if (phoneNumber.length === 10) {
    return phoneNumber.slice(0,3) + '-' + phoneNumber.slice(3,6) + '-' + phoneNumber.slice(6, phoneNumber.length)
  }
  return phoneNumber
}
